<template>
  <v-text-field
    v-model="selected"
    :label="label"
    outlined
    light
    dense
    :rules="rule"
    input-class="dense"
    persistent-hint
  />
</template>

<script>
import formModal from '@/mixins/form-modal';
import { mapState } from 'vuex';

export default {
  name: 'TextFilter',
  mixins: [
    formModal,
  ],
  props: {
    value: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    emailRule: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapState('misc', [
      'formModal',
    ]),
    rule() {
      return this.emailRule ? this.userEmailRules : [];
    },
    selected: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
};
</script>

<style scoped lang="scss">
  .v-input {
    width: 287px !important;
  }
</style>
